export enum FormUserMessages {
  fieldEmail = "UserForm.field.email",
  fieldName = "UserForm.field.name",
  fieldPosition = "UserForm.field.position",
  fieldDescription = "UserForm.field.description",
  fieldActive = "UserForm.field.active",
  fieldInactive = "UserForm.field.inactive",
  addImage = "UserForm.addImage",
  removeImage = "UserForm.removeImage",
  deletionConfirmationTitleModal = "UserForm.modal.deletionConfirmationTitle",
  deletionConfirmationSubtitleModal = "UserForm.modal.deletionConfirmationSubtitleModal"
}

export interface TranslationFormUserMessages {
  [FormUserMessages.fieldEmail]: string;
  [FormUserMessages.fieldName]: string;
  [FormUserMessages.fieldPosition]: string;
  [FormUserMessages.fieldDescription]: string;
  [FormUserMessages.fieldActive]: string;
  [FormUserMessages.fieldInactive]: string;
  [FormUserMessages.addImage]: string;
  [FormUserMessages.removeImage]: string;
  [FormUserMessages.deletionConfirmationTitleModal]: string;
  [FormUserMessages.deletionConfirmationSubtitleModal]: string;
}